"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteWebAuthnCredential = deleteWebAuthnCredential;
const core_1 = require("@aws-amplify/core");
const apis_1 = require("../../foundation/apis");
/**
 * Delete a registered credential for an authenticated user by credentialId
 * @param {DeleteWebAuthnCredentialInput} input The delete input parameters including the credentialId
 * @returns Promise<void>
 * @throws - {@link AuthError}:
 * - Thrown when user is unauthenticated
 * @throws - {@link DeleteWebAuthnCredentialException}
 * - Thrown due to a service error when deleting a WebAuthn credential
 */
async function deleteWebAuthnCredential(input) {
    // Resolve the global AmplifyContext fresh per operation so facade-only
    // configuration is honored (the core `Amplify` singleton is never
    // configured under the new facade).
    return (0, apis_1.deleteWebAuthnCredential)((0, core_1.getGlobalContext)(), input);
}
